import React, { useState, useEffect, useRef } from "react";
import styles from "./find_user_or_firm.module.css";


const FindFirm = ({
  showFirmsList, setShowFirmsList, labelText = null, firmParameter,
  setFirmParameter, firms, customer
}) => {

  const inputRef = useRef(null);

  const [filteredFirms, setFilteredFirms] = useState(firms || []);

  const privatePerson = {
    id: -1,
    name: 'частное лицо',
    inn: null
  }
  const anyPayer = {
    id: -2,
    name: 'любой плательщик',
    inn: null
  }

  useEffect(() => {
    if (!firmParameter) {
      inputRef.current.value = '';
    }
  }, [firmParameter]);


  useEffect(() => {
    setFilteredFirms([anyPayer, privatePerson, ...firms]);
    // eslint-disable-next-line
  }, [firms,]);

  useEffect(() => {
    inputRef.current.value = '';
  }, [customer]);


  const changeFirmName = (e) => {
    setShowFirmsList(true);
    if (e.target.value !== '') {
      setFilteredFirms(firms.filter(firm => {
        return firm.name.toLowerCase().includes(e.target.value.toLowerCase());
      }))
    } else {
      setFilteredFirms([anyPayer, privatePerson, ...firms]);
    }
  }
  const handleClick = (firm) => {
    setFirmParameter(firm.name);
    setShowFirmsList(false);
    inputRef.current.value = `${firm.name}${firm.inn ? `, ИНН ${firm.inn}` : ''}`;
  }

  const clickInputFirm = () => {
    if (firms.length >= 0) {
      setShowFirmsList(!showFirmsList);
    }
  }


  return (
    <div className={styles.container}>
      <label htmlFor="firm" className="label_text">
        {labelText}&nbsp;
        <input
          type="text"
          id="firm" name="firm"
          required={true}
          onChange={changeFirmName}
          className="input"
          ref={inputRef}
          onClick={clickInputFirm}
          placeholder="поиск по названию"
        />
      </label>
      {showFirmsList && filteredFirms.length > 0 &&
        <ul className={styles.list} id='list_firms'>
          {filteredFirms.map(firm => {
            return (
              <li className={styles.item} key={firm.id} onClick={() => handleClick(firm)}>
                {firm.name} {firm.inn ? `, ИНН ${firm.inn}` : ''}
              </li>
            );
          })}
        </ul>
      }
    </div>
  )
}

export default FindFirm;
